
import { CommonFunctions } from '../static/common-functions';
import { DateFunctions } from '../static/date-functions';
import { AppClaims } from '../models/AppClaims';

export class OrderItemSecurity  {

    currentStatus: string;

    pending: string = "CB2F27B0-3599-48CC-A18B-A4B7D787E565".toLowerCase();
    ordered: string = "3D2C81F2-4DC7-44FC-B2E0-D462693F5F19".toLowerCase();
    fullyReceived: string = "B947AC2A-25B2-4D4F-96B4-F3D53970D554".toLowerCase();
    billEntered: string = "CF2E692A-F848-4E0C-B4D4-D6439B4050FE".toLowerCase();
    canceled: string = "1CD15F2C-A5A0-4D61-86AF-2582F1634856".toLowerCase();
    completed: string = "FA457C0E-D19A-458A-BE69-2C4F0ADABFD6".toLowerCase();
    partiallyReceived: string = "5D4FE806-19F8-4455-83A3-C035FB6FB61A".toLowerCase();

    public quantity: boolean = false;
    public price: boolean = false;
    public warehouse: boolean = false;
    public dispatch: boolean = false;
    public class: boolean = false;
    public delete: boolean = false;
    public add: boolean = false;
    public ise: boolean = false
    public dateRequested: boolean = false
    public dateExpected: boolean = false
    public refNum: boolean = false
    public creditCards: boolean = false
    public forEmployee: boolean = false
    public supplier: boolean = false
    public shipTo: boolean = false
    public taxAndFreightOnly: boolean = false;
    public newItemPriceChangeOnly: boolean = false;
    public changePartialReceiveItems: boolean = false;

    constructor(inStatus: string, rights?: AppClaims) {
        this.currentStatus = inStatus;
        if (rights && rights.EditCompletedOrder) {
            this.quantity = true;
            this.price = true;
            this.warehouse = true;
            this.dispatch = true;
            this.class = true;
            this.delete = true;
            this.add = true;
            this.ise = true;
            this.dateRequested = true;
            this.dateExpected = true;
            this.refNum = true;
            this.creditCards = true;
            this.forEmployee = true;
            this.supplier = true;
            this.shipTo = true;
            this.taxAndFreightOnly = false;
            this.newItemPriceChangeOnly = false;
            this.changePartialReceiveItems = false;
        } else {
            switch (inStatus) {
                case this.ordered:
                    this.quantity = true;
                    this.price = true;
                    this.warehouse = true;
                    this.dispatch = true;
                    this.class = true;
                    this.delete = true;
                    this.add = true;
                    this.ise = true;
                    this.dateRequested = true;
                    this.dateExpected = true;
                    this.refNum = true;
                    this.creditCards = true;
                    this.forEmployee = true;
                    this.supplier = true;
                    this.shipTo = true;
                    this.taxAndFreightOnly = false;
                    this.newItemPriceChangeOnly = false;
                    this.changePartialReceiveItems = false;
                    break
                case this.partiallyReceived:
                    this.quantity = true;
                    this.price = true;
                    this.warehouse = false;
                    this.dispatch = false;
                    this.class = false;
                    this.delete = false;
                    this.add = true;
                    this.ise = true;
                    this.dateRequested = true;
                    this.dateExpected = true;
                    this.refNum = true;
                    this.creditCards = true;
                    this.forEmployee = true;
                    this.supplier = false;
                    this.shipTo = true;
                    this.changePartialReceiveItems = true;
                    this.taxAndFreightOnly = false;
                    this.newItemPriceChangeOnly = false;
                    break
                case this.fullyReceived:
                    this.quantity = false;
                    this.price = true;
                    this.warehouse = false;
                    this.dispatch = false;
                    this.class = false;
                    this.delete = false;
                    this.add = true;
                    this.ise = true;
                    this.dateRequested = false;
                    this.dateExpected = false;
                    this.refNum = false;
                    this.creditCards = false;
                    this.forEmployee = false;
                    this.supplier = false;
                    this.shipTo = false;
                    this.taxAndFreightOnly = true;
                    this.newItemPriceChangeOnly = false;
                    this.changePartialReceiveItems = false;
                    break
                case this.billEntered:
                    this.quantity = false;
                    this.price = true;
                    this.warehouse = false;
                    this.dispatch = false;
                    this.class = false;

                    this.delete = false;
                    this.add = true;
                    this.ise = true;
                    this.dateRequested = false;
                    this.dateExpected = false;
                    this.refNum = false;
                    this.creditCards = false;
                    this.forEmployee = false;
                    this.supplier = false;
                    this.shipTo = false;
                    this.taxAndFreightOnly = true;
                    this.newItemPriceChangeOnly = true;
                    this.changePartialReceiveItems = false;
                    break
                case this.canceled:
                    this.quantity = false;
                    this.price = false;
                    this.warehouse = false;
                    this.dispatch = false;
                    this.class = false;

                    this.delete = false;
                    this.add = false;
                    this.ise = true;
                    this.dateRequested = false;
                    this.dateExpected = false;
                    this.refNum = false;
                    this.creditCards = false;
                    this.forEmployee = false;
                    this.supplier = false;
                    this.shipTo = false;
                    this.taxAndFreightOnly = false;
                    this.newItemPriceChangeOnly = false;
                    this.changePartialReceiveItems = false;
                    break
                case this.completed:
                    this.quantity = false;
                    this.price = false;
                    this.warehouse = false;
                    this.dispatch = false;
                    this.class = false;

                    this.delete = false;
                    this.add = false;
                    this.ise = true;
                    this.dateRequested = false;
                    this.dateExpected = false;
                    this.refNum = false;
                    this.creditCards = false;
                    this.forEmployee = false;
                    this.supplier = false;
                    this.shipTo = false;
                    this.taxAndFreightOnly = false;
                    this.newItemPriceChangeOnly = false;
                    this.changePartialReceiveItems = false;
                    break
                default:
                    this.quantity = true;
                    this.price = true;
                    this.warehouse = true;
                    this.dispatch = false;
                    this.class = false;
                    this.dispatch = true;
                    this.class = true;

                    this.delete = true;
                    this.add = true;
                    this.ise = true;
                    this.dateRequested = true;
                    this.dateExpected = true;
                    this.refNum = true;
                    this.creditCards = true;
                    this.forEmployee = true;
                    this.supplier = true;
                    this.shipTo = true;
                    this.taxAndFreightOnly = false;
                    this.newItemPriceChangeOnly = false;
                    this.changePartialReceiveItems = false;

            }
        }
    }

}
